import { useTranslation } from "react-i18next"
import { Message, useMessageContext } from "@/components/ui/message/message"
import { detectType } from "@/components/ui/message/message-file"
import { MessageBody } from "@/components/ui/message/message-body"
import { CornerUpRight } from "lucide-react"
import { useForwardedMessageData } from "@/components/chat/useForwardedMessageData"
import { useForwardedRoomLink } from "@/components/chat/useForwardedRoomLink"
import { isDocumentsRoomJid } from "@/jidUtils"

const MessageForwarded = () => {
  const { t } = useTranslation()
  const { message } = useMessageContext()
  const forwardedMessage = message.forwarded
  if (!forwardedMessage) return null
  const type = detectType(forwardedMessage.fileName)
  const messageData = useForwardedMessageData(forwardedMessage)
  const { roomName, navigateToRoom } = useForwardedRoomLink(
    forwardedMessage.from,
  )
  const author = isDocumentsRoomJid(message?.from ?? "")
    ? ` ${messageData.authorName}`
    : ` ${t("chat.forwarded.label")}`
  const canNavigate = Boolean(roomName)

  return (
    <div>
      <div
        role={canNavigate ? "button" : undefined}
        onClick={canNavigate ? navigateToRoom : undefined}
        className={`flex gap-1 ${canNavigate ? "cursor-pointer hover:underline" : ""}`}
      >
        <CornerUpRight className="h-4 w-4 self-center text-muted-foreground" />
        <Message.Header
          author={author}
          showTimestamp={false}
          className="text-xs font-normal text-muted-foreground"
        />
      </div>
      <MessageBody
        type={type}
        forwarded={true}
        content={messageData.displayBody}
        contentOffset={messageData.displayBodyOffset}
      />
    </div>
  )
}

export { MessageForwarded }
